<svelte:options runes={true} />

<script lang="ts">
	import { page } from '$app/stores';
	import NoAccessPage from '@ui-components/NoAccessPage.svelte';
	import TitleGraphic from '@repo/ui/src/components/TitleGraphic.svelte';
	import MainLoader from '@repo/ui/src/components/MainLoader.svelte';
	import { Card, CardContent } from '@repo/ui/src/components/ui/card';
	import { signInWithCallbackUrl } from '$lib/client-util/client-auth.util';

	interface Props {
		hint?: string;
		children?: import('svelte').Snippet;
		isLoading?: boolean;
	}

	let {
		hint = 'Please sign in or create an account to continue',
		children,
		isLoading
	}: Props = $props();

	const isAuthenticated = $derived(Boolean($page?.data?.dbUser?.email || $page?.data?.session));
</script>

{#if isAuthenticated}
	{#if children}
		{@render children?.()}
	{/if}
{:else if isLoading}
	<!-- Main content container with proper desktop proportions -->
	<div
		class="flex h-screen w-screen flex-col items-center justify-center bg-cover bg-center bg-no-repeat"
		style="background-image: url('/img/colored-bg-ios.png');"
	>
		<div class="flex min-h-screen w-full items-center justify-center p-4">
			<Card class="w-full max-w-md">
				<CardContent>
					<TitleGraphic />
					<MainLoader />
				</CardContent>
			</Card>
		</div>
	</div>
{:else}
	<NoAccessPage {hint} handleSignIn={signInWithCallbackUrl} />
{/if}
